import React from 'react';
import { addDaysToLADateKey } from '../../utils/laDateUtils';

/** Create-mode date range picker for ParticipantBookingPanel, bounded to the stay period. */
const BookingDateRangePicker = ({ fromKey, toKey, stayInKey, stayOutKey, onFromChange, onToChange }) => (
  <div className="pbt-daterange-group">
    <div className="pbt-daterange-group__field">
      <label className="pbt-label">From</label>
      <input
        type="date"
        className="pbt-date-input"
        value={fromKey}
        min={stayInKey}
        max={stayOutKey ? addDaysToLADateKey(stayOutKey, -1) : undefined}
        onChange={(e) => onFromChange(e.target.value)}
      />
    </div>
    <div className="pbt-daterange-group__divider" aria-hidden="true">→</div>
    <div className="pbt-daterange-group__field">
      <label className="pbt-label">To (checkout)</label>
      <input
        type="date"
        className="pbt-date-input"
        value={toKey}
        min={fromKey ? addDaysToLADateKey(fromKey, 1) : undefined}
        max={stayOutKey}
        onChange={(e) => onToChange(e.target.value)}
      />
    </div>
  </div>
);

export default BookingDateRangePicker;
